module.exports = __webpack_public_path__ + "static/media/grayBg.3f5fadc8.jpg";